export enum CollectionType {
	NEW = 'new',
	POPULAR = 'popular',
	UPCOMING = 'upcoming',
	PRICEDROPS = 'pricedrops',
	LEAVING_SOON = 'leaving-soon',
	COMING_SOON = 'coming-soon',
	SEARCH = 'search',
	OFFERS = 'offers',
	WATCHLIST = 'watchlist',
	TITLELIST = 'titlelist',
	SEENLIST = 'seenlist',
	SPORTS = 'sports',
	EDITORIAL = 'editorial',
	// CINEMA_REGION = 'cinema_region',
	// CINEMA_SINGLE = 'cinema_single',

	// for mobile
	GLOBAL = 'global',
}
